(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amicoda-faq"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.virelle-faq').forEach(function (faq) {
    const items = Array.from(faq.querySelectorAll('.virelle-faq__item'));

    if (items.length && !items.some(function (item) { return item.open; })) {
      items[0].open = true;
    }

    items.forEach(function (item) {
      const question = item.querySelector('.virelle-faq__question');

      question.addEventListener('click', function (event) {
        if (item.open) {
          event.preventDefault();
        }
      });

      item.addEventListener('toggle', function () {
        if (!item.open) return;

        items.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.open = false;
          }
        });
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amicoda-product"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initGallery(root) {
    root.querySelectorAll('[data-amicoda-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-gallery-slides]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
      if (!track || !thumbs.length) return;
      let active = 0;
      function select(index) {
        active = (index + thumbs.length) % thumbs.length;
        track.scrollTo({left: active * track.clientWidth, behavior: 'smooth'});
      }
      function mark() {
        active = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === active)));
        const selected = thumbs[active];
        if (selected) {
          const strip = gallery.querySelector('[data-gallery-thumbs]');
          if (selected.offsetLeft < strip.scrollLeft || selected.offsetLeft + selected.offsetWidth > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({left: selected.offsetLeft, behavior: 'smooth'});
          }
        }
      }
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
      gallery.querySelectorAll('[data-gallery-prev]').forEach(button => button.addEventListener('click', () => select(active - 1)));
      gallery.querySelectorAll('[data-gallery-next]').forEach(button => button.addEventListener('click', () => select(active + 1)));
      track.addEventListener('scroll', mark, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
    });
  }
  initGallery(document);
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
